/** Три экрана онбординга. Показываются один раз, при первом запуске без проекта. */
import { useState } from 'react';
import type { ReactElement, ReactNode } from 'react';
import { ActionButton } from '../components/ActionButton';
import { useActions } from '../state/actions';
import { t } from '../i18n';

interface Slide {
  icon: string;
  /** Заголовок с акцентным словом, как в референсе. */
  title: ReactNode;
  text: string;
}

const slides = (): Slide[] => [
  {
    icon: '🎬',
    title: (
      <>
        {t('onboarding.1.title.pre')}<span className="accent">{t('onboarding.1.title.accent')}</span>
      </>
    ),
    text: t('onboarding.1.text'),
  },
  {
    icon: '📎',
    title: (
      <>
        {t('onboarding.2.title.pre')}<span className="accent">{t('onboarding.2.title.accent')}</span>
      </>
    ),
    text: t('onboarding.2.text'),
  },
  {
    icon: '⏱️',
    title: (
      <>
        {t('onboarding.3.title.pre')}<span className="accent">{t('onboarding.3.title.accent')}</span>
      </>
    ),
    text: t('onboarding.3.text'),
  },
];

export function Onboarding(): ReactElement {
  const SLIDES = slides();
  const [index, setIndex] = useState(0);
  const actions = useActions();
  const isLast = index === SLIDES.length - 1;
  const slide = SLIDES[index] ?? SLIDES[0];
  const finish = (): void => actions.finishOnboarding();

  const next = (): void => {
    if (!isLast) {
      setIndex((value) => Math.min(value + 1, SLIDES.length - 1));
      return;
    }
    finish();
  };

  return (
    <>
      {slide ? (
        <>
          <div className="hero glow" aria-hidden="true">
            <div className="hero-icon">{slide.icon}</div>
          </div>
          <h1 className="center">{slide.title}</h1>
          <p className="lead center">{slide.text}</p>
        </>
      ) : null}

      <div className="dots" aria-hidden="true">
        {SLIDES.map((item, position) => (
          <i key={item.icon} className={position === index ? 'on' : ''} />
        ))}
      </div>

      <button type="button" className="btn ghost" onClick={finish}>
        {t('onboarding.skip')}
      </button>

      <ActionButton text={isLast ? t('onboarding.open') : t('onboarding.next')} onClick={next} />
    </>
  );
}
